import React from 'react'
import ZoomMap from './primitives/ZoomMap'
import StatisticPreview from './Components/StatisticPreview'

/**
 * Hidden object
 */
class HiddenObjects extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        const {
            blockData: { t, enableTimer },
        } = this.props
        return (
            <div className={`block __${t}`}>
                {enableTimer ? <StatisticPreview actionsTitle="Number of clicks" /> : null}
                <ZoomMap {...this.props} />
            </div>
        )
    }
}

export default HiddenObjects
